// assets/set-modus.js
// Geschenkset-Modus: erkennt ?set=1, blendet das Schritt-2-Banner ein, versteckt
// die Upsell-Kachel und pflegt die sichtbare Property "Set: Geschenkset".
// Die Verkettung selbst (return_to-Checkbox) funktioniert auch ohne dieses Modul.

// Erkennt den Set-Modus im Query-String ("?set=1" oder "set=1").
export function isSetMode(search) {
  return new URLSearchParams(String(search ?? "")).get("set") === "1";
}

function initSetModus() {
  const banner = document.querySelector("[data-set-banner]");
  const upsell = document.querySelector("[data-set-upsell]");
  const checkbox = document.querySelector("[data-set-checkbox]");
  const propField = document.querySelector("[data-set-property]");

  if (isSetMode(window.location.search)) {
    if (banner) banner.hidden = false;
    if (upsell) upsell.hidden = true;
    // Schritt-2-Artikel als Set markieren; Checkbox entschärfen, damit der
    // vom Browser restaurierte Zustand keine Endlos-Kette auslöst.
    if (propField) propField.disabled = false;
    if (checkbox) checkbox.checked = false;
  } else if (checkbox && propField) {
    // Initial-Sync: Browser restaurieren den Checkbox-Zustand bei Reload/Back
    // ohne change-Event — sonst fehlt Artikel 1 die Set-Markierung.
    propField.disabled = !checkbox.checked;
    checkbox.addEventListener("change", () => {
      propField.disabled = !checkbox.checked;
    });
  }
}

if (typeof document !== "undefined") {
  initSetModus();
}
